// extracted by mini-css-extract-plugin
export default {"title":"DepartmentTitle_title__dbINH"};